import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Sandbox from '../pages/sandbox';

import { hasPermission, nsHasPermission } from '../util';
import { getItemFromLocalStorage } from '../util/localStorageUtils';
import { sandboxResources } from '../util/GlobalConstant';
// import {
//   NSIAD_TAB_LIST,
//   NSIAD_TAB_PAGEID_LIST
// } from '../pages/constants/nsConstants';
import { ROUTE_AMLS_SMART_SCREENING } from '../pages/constants/globalConstants';

export default (authentication) => {
  const NoAccess = () => {
    return <div>No Access</div>;
  };

  //protect route by user role
  const RestrictedRender = (Component) => {
    return nsHasPermission(authentication) ? (
      <Component></Component>
    ) : (
      <NoAccess></NoAccess>
    );
  };

  let params = new URLSearchParams(location.search);

  let nsSandboxPermitted = false;

  let homeUrl = null;

  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    // list of Attributes
    const listOfAttributes = authentication.data;

    listOfAttributes.map((attribute) => {
      const resourceCode = attribute.details?.resource?.resourceCode
        ? attribute.details.resource.resourceCode
        : null;

      if (resourceCode) {
        if (
          resourceCode === sandboxResources.APP_3_RESOURCE_UI_SCREENING_SANDBOX
        ) {
          nsSandboxPermitted = true;
        }
      }
    });
    if (nsSandboxPermitted) {
      homeUrl = '/app/sandbox/ns';
    }
  }

  const routes = (
    <Switch>
      {/* Render routes based on permissions */}
      {homeUrl ? (
        <Route exact path="/app" render={() => <Redirect to={homeUrl} />} />
      ) : null}

      <Route
        exact
        path={`${ROUTE_AMLS_SMART_SCREENING}`}
        render={() => <Redirect to={homeUrl} />}
      />

      {nsSandboxPermitted ? (
        <Route
          exact
          path={'/app/sandbox/ns'}
          render={(routeProps) => <Sandbox {...routeProps} />}
        />
      ) : null}
    </Switch>
  );
  return routes;
};
